import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Moment from 'moment';
import update from 'immutability-helper';
import _ from 'lodash';

import { Helpers } from 'shared-components/helpers/helpers';
import { FormattedMessage } from 'react-intl';

class Multiday extends Component {
  constructor (props) {
    super(props);
    this.extendDay = this.extendDay.bind(this);
    this.removeDay = this.removeDay.bind(this);
  }

  setSchedule (schedule) {
    this.props.scheduleCallback(schedule);
  }

  extendDay () {
    const { schedule = [] } = this.props;
    const addOneDay = (o) => {
      const { m, d, y } = o.date;
      const addDay = Moment(`${m}-${d}-${y}`, 'MM-DD-YYYY').add(1, 'd');
      return { date: Helpers.parseDate(addDay), time: o.time };
    };
    const newDateTimeObj = update(schedule[schedule.length - 1], {
      start: { $apply: addOneDay },
      end: { $apply: addOneDay }
    });
    const newImmutableSchedule = update(schedule, { $push: [newDateTimeObj] });
    this.setSchedule(newImmutableSchedule);
  }

  removeDay () {
    const { schedule = [] } = this.props;
    const newImmutableSchedule = update(schedule, { $splice: [[schedule.length - 1, 1]] });
    if (1 < schedule.length) {
      this.setSchedule(newImmutableSchedule);
    }
  }

  render () {
    const { schedule, reachedMaxDays } = this.props;
    // Checks if the schedule array is not empty and if there are not any undefined values for start and end
    const isStart = schedule.length && _.every(schedule, { start: {} }) ? true : false;
    const isEnd = schedule.length && _.every(schedule, { end: {} }) ? true : false;

    return (
      <div className="col-xs-12 margin-md-top">
        <div className="col-xs-6 text-left text-small no-gutter">
          { !reachedMaxDays
            ? isStart && isEnd
              ? <a onClick={this.extendDay}>
                <FormattedMessage id="elements_date_time.multiday.link_extend" defaultMessage='Extend a day' />
              </a>
              : <span className="text-brand-secondary half-opacity">
                <FormattedMessage id="elements_date_time.multiday.text_extend" defaultMessage='Extend a day' />
              </span>
            : null
          }
        </div>
        { 1 < schedule.length
          ? <div className="col-xs-6 text-right text-small no-gutter">
            <a onClick={this.removeDay}>
              <FormattedMessage id="elements_date_time.multiday.remove" defaultMessage='Remove' />
            </a>
          </div> : ''
        }
      </div>
    );
  }
}

Multiday.propTypes = {
  schedule: PropTypes.array, // schedule to modify
  scheduleCallback: PropTypes.func // function called when subtracting or adding day
};

export default Multiday;
